// =============================================================================
// HidroVerse content — split from the legacy /lib/content.js.
// Imports continue to work from '../lib/content' via the barrel re-export.
// Edit copy here; do NOT touch the barrel in /lib/content.js.
// =============================================================================

// ==============================================================================
// TEAM · JOURNEY · FLOW · COMPLIANCE · STORE
// ==============================================================================

export const TEAM = [
  ["Dirk van Schalkwyk", "CEO", "/team_v2/01.jpg"],
  ["Charmaine Viljoen", "Admin & HR Manager", "/team_v2/02.jpg"],
  ["Ben van der Westhuizen", "Procurement & Sales Support", "/team_v2/03.jpg"],
  ["Jaime Bila", "Senior Technician", "/team_v2/08.jpg"],
  ["Stanley Mashwama", "Internal Sales", "/team_v2/04.jpg"],
  ["Nuno Fonseca", "International Business Development", "/team_v2/05.jpg"],
  ["Deli Nkosi", "Housekeeping & General Assistant", "/team_v2/06.jpg"],
  ["Sifiso Nkuna", "Floor & Sales Co-ordinator", "/team_v2/07.jpg"],
  ["Phathwa", "Technician & Installer", "/team_v2/09.jpg"],
  ["Daniel Hlangwane", "Installer", "/team_v2/10.jpg"],
  ["Simphiwe Vilankulu", "Installer", "/team_v2/11.jpg"],
  ["Tebogo Malope", "Installer", "/team_v2/12.jpg"],
  ["Dumisane Nkosi", "Installer", "/team_v2/13.jpg"],
];

export const JOURNEY = [
  { year: "2016–2020", title: "The Pivot Gutter", body: "R&D commences on the company's first international patent — the Pivot Gutter — laying the foundation as pioneers in the water realm.", tag: "R&D begins" },
  { year: "2020–2021", title: "Tip Gutters → Pivot Pro", body: "Trading begins as Tip Gutters. The need for services complementary to gutters becomes obvious. By 2021 we rebrand to Pivot Pro, focusing on value-added rainwater harvesting.", tag: "Scope expands" },
  { year: "2021–2023", title: "HidroVerse is born", body: "Pivot Pro grows into comprehensive water solutions — a water hub built on extensive knowledge and innovation. We rebrand to HidroVerse, a universal water-systems partner centred on treatment, management and distribution.", tag: "Rebrand" },
  { year: "2025", title: "1,500+ customers · 16 in the team", body: "HidroVerse serves 1,500+ residential, hospitality and commercial customers, with wholesale and retail through an ever-growing water hub. The team grows to 16; the business moves to larger premises; clients now extend across borders.", tag: "Scale" },
  { year: "2026", title: "A new chapter", body: "New brand identity. Expanding international offering. One conviction: good is never the ceiling.", tag: "Today" },
];
